export const gatewaySpecificProps = {
    fiserv: {
      'fiserv-btn-label': 'Pagar Fiserv',
      'fiserv-loading': '<h3>Cargando</h3><p>Aguarde un momento...</p>',
      'fiserv-number-of-installments': 1
    },
    fiservpci: {
      'fiserv-btn-label': 'Pagar con Tarjeta',
      'fiserv-loading': '<h3>Cargando</h3><p>Aguarde un momento...</p>'
    },
    dlocal: {
      'dlocal-btn-label': 'Pagar Dlocal',
      'dlocal-loading': '<h3>Cargando</h3><p>Aguarde un momento...</p>'
    },
    itau: {
      'itau-btn-label': 'Pagar Itau',
      'itau-token': 'itau-token'
    },
    mobbex: {
      'mobbex-btn-label': 'T. Crédito/Débito - Promo'
    }
    // mercadopago y paypal no necesitan props especiales
  };

  